module.exports = __webpack_public_path__ + "static/img/wmsp.0e6c24f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/wmsp.jpg
// module id = C+j7
// module chunks = 1